import classNames from "classnames";
// eslint-disable-next-line no-restricted-imports
import { Link as RouterLink } from "react-router-dom";
import { getPartnerPathnameClient } from "../../getPartnerPathnameClient";
import { CartRoute } from "../miscellaneous/cartFlowSequence";
import { DataTestids } from "../miscellaneous/DataTestids";
import { linkPageClassName } from "../miscellaneous/linkPageClassName";

export type PageId = "samples" | "export" | "marketPlace";
export type PageHash = "" | `#${PageId}`;
export type PagePlusHash = `${CartRoute}${PageHash}` | string;

export type LinkPageProps = React.ComponentProps<typeof RouterLink> & {
  /**
   * required for testing
   */
  readonly "data-testid": DataTestids;

  readonly className?: string;
  readonly to: PagePlusHash;
  readonly tag?: "mkhc-tab" | "mkhc-active-tab" | "mkhc-black-link";
  readonly ariaLabel?: string;
};

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
export function LinkPage(props: LinkPageProps) {
  const className = linkPageClassName(props.tag);

  return (
    <RouterLink
      {...props}
      to={`${getPartnerPathnameClient(true)}${props.to}`}
      className={classNames(className, props.className)}
      aria-label={props.ariaLabel}
    >
      {props.children}
    </RouterLink>
  );
}
